angular
  .module("erp.other.membershipService", ["ui.router", "membershipService.service"])
  .config([
    "$stateProvider",
    "$httpProvider",
    function($stateProvider, $httpProvider) {
      $httpProvider.defaults.headers.put["Content-Type"] = "application/json;charset=utf-8";
      $stateProvider.state("membershipService", {
        url: "/erp/other/membershipService",
        templateUrl: "tpl/outbox.htm",
        controllerAs: "vm",
        controller: "baseCtrl",
        resolve: {},
      });
    },
  ])

  .controller("baseCtrl", [
    "$scope",
    "$http",
    "$sce",
    "$q",
    "kit",
    function($scope, $http, $sce, $q, kit) {
      var vm = this;
      var params = kit.getParams();
      vm.tpl = "tpl/outbox.htm";
      vm.alertShow1 = true;

      function resetFeeList(data) {
        var ret = [];
        angular.forEach(data, function(item) {
          var finder = null;
          // 替换 find 方法为 angular.forEach 实现
          angular.forEach(ret, function(item1) {
            if (item1.businessType === item.businessType) {
              finder = item1;
            }
          });

          // 替换 angular.pick 为手动创建对象
          var obj = {
            id: item.id,
            unitPay: item.unitPay,
            durationUnitMount: item.durationUnitMount,
            extraDays: item.extraDays
          };

          if (finder) {
            finder.list.push(obj);
          } else {
            var listItem = {
              title: item.remark,
              businessType: item.businessType,
              list: [obj]
            };
            ret.push(listItem);
          }
        });
        return ret;
      }


      function groupList(list, isCombine) {
        if (list.shop_count_other_amazon) {
            list.shop_count_other_amazon.servicePoint = 'shop_count_amazon';
        }
        if (list.shop_count_other_ebay) {
            list.shop_count_other_ebay.servicePoint = 'shop_count_ebay';
        }

        // 手动实现 filter 功能
        function filterList(list, group) {
            var result = [];
            for (var key in list) {
                if (list.hasOwnProperty(key) && list[key].serviceGroup === group) {
                    result.push(list[key]);
                }
            }
            return result;
        }

        // 手动实现 indexOf 功能
        function indexOf(arr, item) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] === item) {
                    return i;
                }
            }
            return -1;
        }

        var ret = [
            {
                title: '通用服务',
                values: filterList(list, '通用服务')
            },
            {
                title: '产品刊登',
                values: filterList(list, '产品刊登')
            },
            {
                title: '图片管理',
                values: filterList(list, '图片管理')
            },
            {
                title: '客户管理',
                values: filterList(list, '客户管理')
            },
            {
                title: '数据统计',
                values: filterList(list, '数据统计')
            },
            {
                title: '物流管理',
                values: filterList(list, '物流管理')
            },
            {
                title: '其它功能',
                values: (function() {
                    var result = [];
                    var arr = ['通用服务', '产品刊登', '客户管理', '数据统计', '物流管理', '图片管理'];
                    for (var key in list) {
                        if (list.hasOwnProperty(key)) {
                            var item = list[key];
                            if (indexOf(arr, item.serviceGroup) === -1) {
                                result.push(item);
                            }
                        }
                    }
                    return result;
                })()
            }
        ];

        if (!isCombine) {
          return ret;
        }

        var combines = [
            {
                title: '产品刊登',
                servivcePoint: 'product_timing_publish_',
                serivcePointName: '产品定时发布',
                serivcePointNameRep: '产品定时发布',
                note: '包括'
            },
            {
                title: '通用服务',
                servivcePoint: 'shop_count_other_',
                serivcePointName: '其它店铺数',
                serivcePointNameRep: '店铺数',
                note: '包括:'
            }
        ];

        // 手动实现 each 功能
        for (var i = 0; i < combines.length; i++) {
            var comb = combines[i];
            // 假设 exports.combine 是一个已定义的函数
            if (typeof exports !== 'undefined' && typeof exports.combine === 'function') {
                exports.combine(ret, comb);
            }
        }

        return ret;
      }

      vm.vipList = [
        {
          id: 54,
          gmtCreate: 1615899701000,
          gmtModified: 1615899701000,
          creator: "admin",
          modifier: "admin",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          subject: "vip0 30天",
          businessType: "vip0",
          remark: "基础VIP",
          threaholdCount: 1,
          discount: 1,
          durationUnit: "d",
          durationUnitMount: 30,
          capacityUnit: null,
          capacityUnitMount: null,
          unitPay: 168,
          givedAmount: null,
          payCatagoryInfoId: null,
          extraDays: null,
          promotionPrice: null,
          payVIPType: "CANNOT_BUY_VIP",
          canPayVIP: false,
        },
        {
          id: 55,
          gmtCreate: 1615899701000,
          gmtModified: 1615899701000,
          creator: "admin",
          modifier: "admin",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          subject: "vip0 90天",
          businessType: "vip0",
          remark: "基础VIP",
          threaholdCount: 1,
          discount: 1,
          durationUnit: "d",
          durationUnitMount: 90,
          capacityUnit: null,
          capacityUnitMount: null,
          unitPay: 480,
          givedAmount: null,
          payCatagoryInfoId: null,
          extraDays: null,
          promotionPrice: null,
          payVIPType: "CANNOT_BUY_VIP",
          canPayVIP: false,
        },
        {
          id: 10,
          gmtCreate: 1541591480000,
          gmtModified: 1541591480000,
          creator: "ll",
          modifier: "ll",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          subject: "vip1 360天",
          businessType: "vip1",
          remark: "VIP 1",
          threaholdCount: 1,
          discount: 1,
          durationUnit: "d",
          durationUnitMount: 360,
          capacityUnit: "",
          capacityUnitMount: null,
          unitPay: 1680,
          givedAmount: null,
          payCatagoryInfoId: null,
          extraDays: null,
          promotionPrice: null,
          payVIPType: "CANNOT_BUY_VIP",
          canPayVIP: false,
        },
        {
          id: 11,
          gmtCreate: 1541591480000,
          gmtModified: 1541591480000,
          creator: "ll",
          modifier: "ll",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          subject: "vip2 360天",
          businessType: "vip2",
          remark: "VIP 2",
          threaholdCount: 1,
          discount: 1,
          durationUnit: "d",
          durationUnitMount: 360,
          capacityUnit: "",
          capacityUnitMount: null,
          unitPay: 3999,
          givedAmount: null,
          payCatagoryInfoId: null,
          extraDays: null,
          promotionPrice: null,
          payVIPType: "CANNOT_BUY_VIP",
          canPayVIP: false,
        },
        {
          id: 12,
          gmtCreate: 1541591480000,
          gmtModified: 1541591480000,
          creator: "ll",
          modifier: "ll",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          subject: "vip3 360天",
          businessType: "vip3",
          remark: "VIP 3",
          threaholdCount: 1,
          discount: 1,
          durationUnit: "d",
          durationUnitMount: 360,
          capacityUnit: "",
          capacityUnitMount: null,
          unitPay: 9888,
          givedAmount: null,
          payCatagoryInfoId: null,
          extraDays: null,
          promotionPrice: null,
          payVIPType: "CANNOT_BUY_VIP",
          canPayVIP: false,
        },
        {
          id: 13,
          gmtCreate: 1541591480000,
          gmtModified: 1541591480000,
          creator: "ll",
          modifier: "ll",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          subject: "VIP4 360天",
          businessType: "vip4",
          remark: "VIP 4",
          threaholdCount: 1,
          discount: 1,
          durationUnit: "d",
          durationUnitMount: 360,
          capacityUnit: "",
          capacityUnitMount: null,
          unitPay: 19800,
          givedAmount: null,
          payCatagoryInfoId: null,
          extraDays: null,
          promotionPrice: null,
          payVIPType: "RENEW_VIP",
          canPayVIP: true,
        },
        {
          id: 56,
          gmtCreate: 1615899701000,
          gmtModified: 1615899701000,
          creator: "admin",
          modifier: "admin",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          subject: "vip5 360天",
          businessType: "vip5",
          remark: "VIP 5",
          threaholdCount: 1,
          discount: 1,
          durationUnit: "d",
          durationUnitMount: 360,
          capacityUnit: null,
          capacityUnitMount: null,
          unitPay: 39800,
          givedAmount: null,
          payCatagoryInfoId: null,
          extraDays: null,
          promotionPrice: null,
          payVIPType: "UPGRADE_VIP",
          canPayVIP: true,
        },
      ];

      var dataMap = {
        shop_count_other_other: {
          id: 89,
          gmtCreate: 1685449230000,
          gmtModified: 1685449230000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_other",
          serivcePointName: "自定义店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        customer_distribution: {
          id: 25,
          gmtCreate: 1541591665000,
          gmtModified: 1541591665000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "customer_distribution",
          serivcePointName: "客户分布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: null,
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: null,
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: null,
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: null,
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: null,
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "数据统计",
          seq: "50",
          isOpened: "y",
        },
        shop_count_other_TikTokFs: {
          id: 141,
          gmtCreate: 1719818024000,
          gmtModified: 1719818037000,
          creator: "pyc",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_TikTokFs",
          serivcePointName: "Tiktok全托管店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        subaccounts_count: {
          id: 5,
          gmtCreate: 1541591663000,
          gmtModified: 1541591663000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "subaccounts_count",
          serivcePointName: "子账号",
          normal: "limit",
          normalLimit: "3",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "30",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "200",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "200",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "200",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "60",
          isOpened: "y",
        },
        edm_email_num: {
          id: 52,
          gmtCreate: 1541591667000,
          gmtModified: 1677760684000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "edm_email_num",
          serivcePointName: "邮件营销群发数",
          normal: "no",
          normalLimit: "0",
          normalLimitUnit: "封",
          vip0: "no",
          vip0Limit: "0",
          vip0LimitUnit: "封",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "封/年付",
          vip2: "limit",
          vip2Limit: "3000",
          vip2LimitUnit: "封/年付",
          vip3: "limit",
          vip3Limit: "5000",
          vip3LimitUnit: "封/年付",
          vip4: "limit",
          vip4Limit: "10000",
          vip4LimitUnit: "封/年付",
          vip5: "limit",
          vip5Limit: "20000",
          vip5LimitUnit: "封/年付",
          serviceNew: "n",
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_pdd: {
          id: 83,
          gmtCreate: 1664245089000,
          gmtModified: 1664245089000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_pdd",
          serivcePointName: "Temu全托管店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_Ozon: {
          id: 66,
          gmtCreate: 1629449198000,
          gmtModified: 1629449198000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_Ozon",
          serivcePointName: "ozon店铺数",
          normal: "no",
          normalLimit: "0",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "1",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "35",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: "y",
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        commodity_statistics: {
          id: 58,
          gmtCreate: 1567416966000,
          gmtModified: 1567416966000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "commodity_statistics",
          serivcePointName: "商品统计",
          normal: "no",
          normalLimit: "",
          normalLimitUnit: null,
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: "",
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: "",
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: "",
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: "",
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "数据统计",
          seq: "60",
          isOpened: "y",
        },
        shop_count_other_cd: {
          id: 40,
          gmtCreate: 1541591666000,
          gmtModified: 1541591666000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_cd",
          serivcePointName: "Cdiscount店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_jumia: {
          id: 122,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_jumia",
          serivcePointName: "Jumia产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        online_meitu: {
          id: 27,
          gmtCreate: 1541591666000,
          gmtModified: 1541591666000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "online_meitu",
          serivcePointName: "在线美图",
          normal: "limit",
          normalLimit: "30",
          normalLimitUnit: "次/天",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "次/天",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "次/天",
          vip2: "limitless",
          vip2Limit: null,
          vip2LimitUnit: "",
          vip3: "limitless",
          vip3Limit: null,
          vip3LimitUnit: "",
          vip4: "limitless",
          vip4Limit: null,
          vip4LimitUnit: "",
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "图片管理",
          seq: "20",
          isOpened: "y",
        },
        shop_count_other_AeRu: {
          id: 144,
          gmtCreate: 1723550058000,
          gmtModified: 1723550063000,
          creator: "pyc",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_AeRu",
          serivcePointName: "速卖通俄罗斯店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_daraz: {
          id: 82,
          gmtCreate: 1664245089000,
          gmtModified: 1664245089000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_daraz",
          serivcePointName: "daraz店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_Allegro: {
          id: 63,
          gmtCreate: 1591338210000,
          gmtModified: 1591338210000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_Allegro",
          serivcePointName: "allegro店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_octopia: {
          id: 148,
          gmtCreate: 1752828370000,
          gmtModified: 1752828370000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_octopia",
          serivcePointName: "Octopia店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_MOshop: {
          id: 120,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_MOshop",
          serivcePointName: "MOshop产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        product_lib: {
          id: 54,
          gmtCreate: 1557391915000,
          gmtModified: 1557391921000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_lib",
          serivcePointName: "商品库",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: null,
          vip0: "limit",
          vip0Limit: "50",
          vip0LimitUnit: "个",
          vip1: "limitless",
          vip1Limit: null,
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: null,
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: null,
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: null,
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: "200",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "50",
          isOpened: "y",
        },
        order_statistics: {
          id: 15,
          gmtCreate: 1541591665000,
          gmtModified: 1541591665000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "order_statistics",
          serivcePointName: "订单统计",
          normal: "no",
          normalLimit: "",
          normalLimitUnit: null,
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: "",
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: "",
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: "",
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: "",
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "数据统计",
          seq: "20",
          isOpened: "y",
        },
        custom_label_count: {
          id: 132,
          gmtCreate: 1703733323000,
          gmtModified: 1703733323000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "custom_label_count",
          serivcePointName: "自定义标签数",
          normal: "limit",
          normalLimit: "20",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "50",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "100",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "200",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "300",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "400",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "99",
          isOpened: "y",
        },
        shop_count_other_amazon: {
          id: 33,
          gmtCreate: 1541591666000,
          gmtModified: 1541591666000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_amazon",
          serivcePointName: "amazon店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "35",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "20",
          isOpened: "y",
        },
        shop_count_other_shopline: {
          id: 84,
          gmtCreate: 1664245089000,
          gmtModified: 1664245089000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_shopline",
          serivcePointName: "shopline店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_magento: {
          id: 42,
          gmtCreate: 1541591666000,
          gmtModified: 1541591666000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_magento",
          serivcePointName: "magento店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_Tospino: {
          id: 121,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_Tospino",
          serivcePointName: "Tospino产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_pdd: {
          id: 123,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_pdd",
          serivcePointName: "Pdd产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        shop_count_lazada: {
          id: 2,
          gmtCreate: 1541591663000,
          gmtModified: 1541591663000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_lazada",
          serivcePointName: "lazada店铺数",
          normal: "limit",
          normalLimit: "5",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "15",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "15",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "35",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "35",
          isOpened: "y",
        },
        shipping_templates: {
          id: 16,
          gmtCreate: 1541591665000,
          gmtModified: 1541591665000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shipping_templates",
          serivcePointName: "运费模板",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: "",
          vip1LimitUnit: "",
          vip2: "limitless",
          vip2Limit: "",
          vip2LimitUnit: "",
          vip3: "limitless",
          vip3Limit: "",
          vip3LimitUnit: "",
          vip4: "limitless",
          vip4Limit: "",
          vip4LimitUnit: "",
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "物流管理",
          seq: "10",
          isOpened: "y",
        },
        shop_count_other_Thisshop: {
          id: 68,
          gmtCreate: 1639619745000,
          gmtModified: 1639619745000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_Thisshop",
          serivcePointName: "Thisshop店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_JDThailan: {
          id: 119,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_JDThailan",
          serivcePointName: "JDThailand产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_dh: {
          id: 31,
          gmtCreate: 1541591666000,
          gmtModified: 1541591666000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_dh",
          serivcePointName: "敦煌店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_TemuSemi: {
          id: 142,
          gmtCreate: 1721009889000,
          gmtModified: 1721009889000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_TemuSemi",
          serivcePointName: "Temu半托管店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_shopee: {
          id: 3,
          gmtCreate: 1541591663000,
          gmtModified: 1541591663000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_shopee",
          serivcePointName: "shopee店铺数",
          normal: "limit",
          normalLimit: "5",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "15",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "15",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "35",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "38",
          isOpened: "y",
        },
        shop_count_other_Tospino: {
          id: 81,
          gmtCreate: 1664245089000,
          gmtModified: 1664245089000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_Tospino",
          serivcePointName: "tospino店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_ml: {
          id: 71,
          gmtCreate: 1639619745000,
          gmtModified: 1639619745000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_ml",
          serivcePointName: "美客多产品定时发布",
          normal: "no",
          normalLimit: "",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_kikuu: {
          id: 125,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_kikuu",
          serivcePointName: "Kikuu产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        shop_count_sheinSemi: {
          id: 143,
          gmtCreate: 1721723588000,
          gmtModified: 1721723609000,
          creator: "pyc",
          modifier: "pyc",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_sheinSemi",
          serivcePointName: "Shein半托管店铺数",
          normal: "limit",
          normalLimit: "1",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "35",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: "y",
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_lzdChoice: {
          id: 133,
          gmtCreate: 1704944302000,
          gmtModified: 1704944302000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_lzdChoice",
          serivcePointName: "lazada全托管店铺数",
          normal: "limit",
          normalLimit: "5",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "15",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "15",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "35",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "36",
          isOpened: "y",
        },
        product_timing_publish_ezbuy: {
          id: 126,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_ezbuy",
          serivcePointName: "ezbuy产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_taoWorld: {
          id: 147,
          gmtCreate: 1752029531000,
          gmtModified: 1752029531000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_taoWorld",
          serivcePointName: "淘宝跨境店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_tiktok: {
          id: 124,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_tiktok",
          serivcePointName: "Tiktok产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_jumia: {
          id: 79,
          gmtCreate: 1664245089000,
          gmtModified: 1664245089000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_jumia",
          serivcePointName: "jumia店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_Fanno: {
          id: 77,
          gmtCreate: 1664245089000,
          gmtModified: 1664245089000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_Fanno",
          serivcePointName: "fanno店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_ebay: {
          id: 32,
          gmtCreate: 1541591666000,
          gmtModified: 1541591666000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_ebay",
          serivcePointName: "ebay店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "35",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "25",
          isOpened: "y",
        },
        product_timing_publish_lazada: {
          id: 113,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_lazada",
          serivcePointName: "Lazada产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_joom: {
          id: 28,
          gmtCreate: 1541591666000,
          gmtModified: 1541591666000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_joom",
          serivcePointName: "Joom产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: null,
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_wb: {
          id: 138,
          gmtCreate: 1716369493000,
          gmtModified: 1716369493000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_wb",
          serivcePointName: "Wildberries店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_shopyy: {
          id: 118,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_shopyy",
          serivcePointName: "Shopyy产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_kilimall: {
          id: 117,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_kilimall",
          serivcePointName: "Kilimall产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_Kaufland: {
          id: 76,
          gmtCreate: 1664245089000,
          gmtModified: 1664245089000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_Kaufland",
          serivcePointName: "kaufland店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_wc: {
          id: 48,
          gmtCreate: 1541591667000,
          gmtModified: 1541591667000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_wc",
          serivcePointName: "woocommerce店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        add_order: {
          id: 145,
          gmtCreate: 1735623607000,
          gmtModified: 1735623607000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "add_order",
          serivcePointName: "手工创建订单",
          normal: "limit",
          normalLimit: "100",
          normalLimitUnit: "条/天",
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: "",
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: "",
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: "",
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: "",
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "其他功能",
          seq: "50",
          isOpened: "y",
        },
        shop_count_ml: {
          id: 64,
          gmtCreate: 1615899716000,
          gmtModified: 1615899716000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_ml",
          serivcePointName: "Mercadolibre店铺数",
          normal: "limit",
          normalLimit: "1",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "3",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "35",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: "y",
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_fm: {
          id: 46,
          gmtCreate: 1541591667000,
          gmtModified: 1541591667000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_fm",
          serivcePointName: "factorymarket店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_ozon: {
          id: 72,
          gmtCreate: 1639619745000,
          gmtModified: 1639619745000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_ozon",
          serivcePointName: "Ozon产品定时发布",
          normal: "no",
          normalLimit: "",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_walmart: {
          id: 47,
          gmtCreate: 1541591667000,
          gmtModified: 1541591667000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_walmart",
          serivcePointName: "walmart店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        auto_replenishment_ebay: {
          id: 12,
          gmtCreate: 1541591664000,
          gmtModified: 1541591664000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "auto_replenishment_ebay",
          serivcePointName: "eBay自动补货",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "1500",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1500",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "3000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "5000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "5000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "5000",
          vip5LimitUnit: "个",
          serviceNew: "n",
          note: null,
          serviceGroup: "客户管理",
          seq: "10",
          isOpened: "y",
        },
        gather_number: {
          id: 74,
          gmtCreate: 1651712810000,
          gmtModified: 1651712816000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "gather_number",
          serivcePointName: "采集商品数",
          normal: "limit",
          normalLimit: "800",
          normalLimitUnit: "个/天",
          vip0: "limit",
          vip0Limit: "1500",
          vip0LimitUnit: "个/天",
          vip1: "limit",
          vip1Limit: "3000",
          vip1LimitUnit: "个/天",
          vip2: "limit",
          vip2Limit: "5000",
          vip2LimitUnit: "个/天",
          vip3: "limit",
          vip3Limit: "8000",
          vip3LimitUnit: "个/天",
          vip4: "limit",
          vip4Limit: "12000",
          vip4LimitUnit: "个/天",
          vip5: "limit",
          vip5Limit: "18000",
          vip5LimitUnit: "个/天",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "99",
          isOpened: "y",
        },
        shop_count_shein: {
          id: 127,
          gmtCreate: 1697769607000,
          gmtModified: 1697769607000,
          creator: "ybw",
          modifier: "ybw",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_shein",
          serivcePointName: "Shein全托管店铺数",
          normal: "limit",
          normalLimit: "1",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "35",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: "y",
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_Yandex: {
          id: 137,
          gmtCreate: 1716369493000,
          gmtModified: 1716369493000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_Yandex",
          serivcePointName: "yandex店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_kilimall: {
          id: 53,
          gmtCreate: 1541591667000,
          gmtModified: 1541591667000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_kilimall",
          serivcePointName: "kilimall店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_ebay: {
          id: 114,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_ebay",
          serivcePointName: "Ebay产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_wish: {
          id: 26,
          gmtCreate: 1541591666000,
          gmtModified: 1541591666000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_wish",
          serivcePointName: "Wish产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        shop_count_TemuUs: {
          id: 149,
          gmtCreate: 1757315042000,
          gmtModified: 1757315046000,
          creator: "pyc",
          modifier: "pyc",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_TemuUs",
          serivcePointName: "Temu本土店铺数",
          normal: "limit",
          normalLimit: "1",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "35",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: "y",
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_sheinMX: {
          id: 128,
          gmtCreate: 1697769607000,
          gmtModified: 1697769607000,
          creator: "ybw",
          modifier: "ybw",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_sheinMX",
          serivcePointName: "Shein自运营店铺数",
          normal: "limit",
          normalLimit: "1",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "35",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: "y",
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        img_capacity: {
          id: 22,
          gmtCreate: 1541591665000,
          gmtModified: 1541591665000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "img_capacity",
          serivcePointName: "图片容量",
          normal: "no",
          normalLimit: "0",
          normalLimitUnit: "mb",
          vip0: "limit",
          vip0Limit: "500",
          vip0LimitUnit: "mb",
          vip1: "limit",
          vip1Limit: "500",
          vip1LimitUnit: "mb",
          vip2: "limit",
          vip2Limit: "800",
          vip2LimitUnit: "mb",
          vip3: "limit",
          vip3Limit: "1200",
          vip3LimitUnit: "mb",
          vip4: "limit",
          vip4Limit: "1200",
          vip4LimitUnit: "mb",
          vip5: "limit",
          vip5Limit: "1200",
          vip5LimitUnit: "mb",
          serviceNew: null,
          note: "在原有基础上累加",
          serviceGroup: "图片管理",
          seq: "10",
          isOpened: "y",
        },
        goods_statistics: {
          id: 14,
          gmtCreate: 1541591665000,
          gmtModified: 1541591665000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "goods_statistics",
          serivcePointName: "产品统计",
          normal: "no",
          normalLimit: "",
          normalLimitUnit: null,
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: "",
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: "",
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: "",
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: "",
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "数据统计",
          seq: "10",
          isOpened: "y",
        },
        shop_count_wish: {
          id: 1,
          gmtCreate: 1541591662000,
          gmtModified: 1541591662000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_wish",
          serivcePointName: "wish店铺数",
          normal: "limit",
          normalLimit: "3",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "35",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "10",
          isOpened: "y",
        },
        data_migration: {
          id: 9,
          gmtCreate: 1541591664000,
          gmtModified: 1541591664000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "data_migration",
          serivcePointName: "数据搬家",
          normal: "limit",
          normalLimit: "20",
          normalLimitUnit: "条/天",
          vip0: "limit",
          vip0Limit: "10000",
          vip0LimitUnit: "条/天",
          vip1: "limit",
          vip1Limit: "10000",
          vip1LimitUnit: "条/天",
          vip2: "limitless",
          vip2Limit: "",
          vip2LimitUnit: "",
          vip3: "limitless",
          vip3Limit: "",
          vip3LimitUnit: "",
          vip4: "limitless",
          vip4Limit: "",
          vip4LimitUnit: "",
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "20",
          isOpened: "y",
        },
        product_template: {
          id: 8,
          gmtCreate: 1541591664000,
          gmtModified: 1541591664000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_template",
          serivcePointName: "产品模块",
          normal: "limit",
          normalLimit: "10",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "100",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "100",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "200",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "400",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "400",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "400",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "10",
          isOpened: "y",
        },
        claim_attribute_mapping: {
          id: 131,
          gmtCreate: 1698399838000,
          gmtModified: 1698399845000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "claim_attribute_mapping",
          serivcePointName: "映射管理",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: null,
          vip0: "no",
          vip0Limit: null,
          vip0LimitUnit: null,
          vip1: "limitless",
          vip1Limit: null,
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: null,
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: null,
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: null,
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: null,
          vip5LimitUnit: null,
          serviceNew: null,
          note: "包括复制到",
          serviceGroup: "其他功能",
          seq: "70",
          isOpened: "y",
        },
        shop_count_other_Coupang: {
          id: 69,
          gmtCreate: 1639619745000,
          gmtModified: 1639619745000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_Coupang",
          serivcePointName: "Coupang店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_kikuu: {
          id: 43,
          gmtCreate: 1541591666000,
          gmtModified: 1541591666000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_kikuu",
          serivcePointName: "kikuu店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_newEgg: {
          id: 67,
          gmtCreate: 1639619745000,
          gmtModified: 1639619745000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_newEgg",
          serivcePointName: "NewEgg店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_shopeev2: {
          id: 115,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_shopeev2",
          serivcePointName: "Shopee产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        auto_relist_ebay: {
          id: 13,
          gmtCreate: 1541591665000,
          gmtModified: 1541591665000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "auto_relist_ebay",
          serivcePointName: "eBay自动重新刊登",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "1500",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1500",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "3000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "5000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "5000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "5000",
          vip5LimitUnit: "个",
          serviceNew: "n",
          note: null,
          serviceGroup: "客户管理",
          seq: "20",
          isOpened: "y",
        },
        product_timing_publish_tiktok_fs: {
          id: 140,
          gmtCreate: 1716625412000,
          gmtModified: 1716625412000,
          creator: "yw",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_tiktok_fs",
          serivcePointName: "tiktok全托管产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_allegro: {
          id: 134,
          gmtCreate: 1706771008000,
          gmtModified: 1706771008000,
          creator: "yw",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_allegro",
          serivcePointName: "allegro产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        customer_statistics: {
          id: 23,
          gmtCreate: 1541591665000,
          gmtModified: 1541591665000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "customer_statistics",
          serivcePointName: "客户统计",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: null,
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: null,
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: null,
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: null,
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: null,
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "数据统计",
          seq: "30",
          isOpened: "y",
        },
        product_timing_publish_shopee_sc: {
          id: 139,
          gmtCreate: 1716625376000,
          gmtModified: 1716625376000,
          creator: "yw",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_shopee_sc",
          serivcePointName: "shopee全托管产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_TikTok: {
          id: 70,
          gmtCreate: 1639619745000,
          gmtModified: 1639619745000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_TikTok",
          serivcePointName: "TikTok店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_shoplazza: {
          id: 85,
          gmtCreate: 1664245089000,
          gmtModified: 1664245089000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_shoplazza",
          serivcePointName: "店匠店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        profit_statistics: {
          id: 24,
          gmtCreate: 1541591665000,
          gmtModified: 1541591665000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "profit_statistics",
          serivcePointName: "利润统计",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: null,
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: null,
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: null,
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: null,
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: null,
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: "包括订单利润、利润统计",
          serviceGroup: "数据统计",
          seq: "40",
          isOpened: "y",
        },
        offline_notify_wish: {
          id: 30,
          gmtCreate: 1541591666000,
          gmtModified: 1541591666000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "offline_notify_wish",
          serivcePointName: "wish未上网提醒",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: null,
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: null,
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: null,
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: null,
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: null,
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "物流管理",
          seq: "20",
          isOpened: "y",
        },
        shop_count_other_ali1688: {
          id: 34,
          gmtCreate: 1541591666000,
          gmtModified: 1541591666000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_ali1688",
          serivcePointName: "1688店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        log_view: {
          id: 7,
          gmtCreate: 1541591663000,
          gmtModified: 1541591663000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "log_view",
          serivcePointName: "操作日志保留天数",
          normal: "limit",
          normalLimit: "30",
          normalLimitUnit: "天",
          vip0: "limit",
          vip0Limit: "60",
          vip0LimitUnit: "天",
          vip1: "limit",
          vip1Limit: "60",
          vip1LimitUnit: "天",
          vip2: "limit",
          vip2Limit: "90",
          vip2LimitUnit: "天",
          vip3: "limit",
          vip3Limit: "180",
          vip3LimitUnit: "天",
          vip4: "limit",
          vip4Limit: "180",
          vip4LimitUnit: "天",
          vip5: "limit",
          vip5Limit: "180",
          vip5LimitUnit: "天",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "80",
          isOpened: "y",
        },
        shop_count_other_shopyy: {
          id: 49,
          gmtCreate: 1541591667000,
          gmtModified: 1541591667000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_shopyy",
          serivcePointName: "shopyy店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_shopee_scs: {
          id: 136,
          gmtCreate: 1714379668000,
          gmtModified: 1714379668000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_shopee_scs",
          serivcePointName: "shopee全托管店铺数",
          normal: "limit",
          normalLimit: "5",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "15",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "15",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "35",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "39",
          isOpened: "y",
        },
        shopee_auto_boost: {
          id: 57,
          gmtCreate: 1565867806000,
          gmtModified: 1565867806000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shopee_auto_boost",
          serivcePointName: "shopee自动置顶",
          normal: "no",
          normalLimit: "",
          normalLimitUnit: null,
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: "",
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: "",
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: "",
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: "",
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "客户管理",
          seq: "60",
          isOpened: "y",
        },
        product_timing_publish_dh: {
          id: 11,
          gmtCreate: 1541591664000,
          gmtModified: 1541591664000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_dh",
          serivcePointName: "敦煌产品定时发布",
          normal: "no",
          normalLimit: "",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        product_timing_publish_shopify: {
          id: 116,
          gmtCreate: 1688701523000,
          gmtModified: 1688701523000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_timing_publish_shopify",
          serivcePointName: "Shopify产品定时发布",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "1000",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "1000",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "2000",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "3000",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "3000",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "3000",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_ezbuy: {
          id: 50,
          gmtCreate: 1541591667000,
          gmtModified: 1541591667000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_ezbuy",
          serivcePointName: "ezbuy店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        pb_shop_statistics: {
          id: 65,
          gmtCreate: 1615899727000,
          gmtModified: 1615899727000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "pb_shop_statistics",
          serivcePointName: "pd店铺表现",
          normal: "no",
          normalLimit: "",
          normalLimitUnit: null,
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: "",
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: "",
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: "",
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: "",
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "pd店铺表现",
          seq: "60",
          isOpened: "y",
        },
        all_rule_count: {
          id: 56,
          gmtCreate: 1565594960000,
          gmtModified: 1565594960000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "all_rule_count",
          serivcePointName: "自定义规则",
          normal: "limit",
          normalLimit: "30",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "100",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "100",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "200",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "300",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "400",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "400",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "90",
          isOpened: "y",
        },
        product_imp_exp: {
          id: 10,
          gmtCreate: 1541591664000,
          gmtModified: 1541591664000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "product_imp_exp",
          serivcePointName: "产品导入/导出",
          normal: "limit",
          normalLimit: "1",
          normalLimitUnit: "次/天",
          vip0: "limit",
          vip0Limit: "5000",
          vip0LimitUnit: "个/天",
          vip1: "limit",
          vip1Limit: "5000",
          vip1LimitUnit: "个/天",
          vip2: "limitless",
          vip2Limit: "",
          vip2LimitUnit: "",
          vip3: "limitless",
          vip3Limit: "",
          vip3LimitUnit: "",
          vip4: "limitless",
          vip4Limit: "",
          vip4LimitUnit: "",
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "30",
          isOpened: "y",
        },
        shop_count_other_Fnac: {
          id: 80,
          gmtCreate: 1664245089000,
          gmtModified: 1664245089000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_Fnac",
          serivcePointName: "fnac店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shop_count_other_jingdong: {
          id: 86,
          gmtCreate: 1664245089000,
          gmtModified: 1664245089000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_jingdong",
          serivcePointName: "京东全球贸易店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        yun_blacklist: {
          id: 17,
          gmtCreate: 1541591665000,
          gmtModified: 1541591665000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "yun_blacklist",
          serivcePointName: "云黑名单",
          normal: "no",
          normalLimit: "",
          normalLimitUnit: null,
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: "",
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: "",
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: "",
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: "",
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "客户管理",
          seq: "30",
          isOpened: "y",
        },
        shop_count_other_joom: {
          id: 45,
          gmtCreate: 1541591667000,
          gmtModified: 1541591667000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_joom",
          serivcePointName: "joom店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        shopee_collection: {
          id: 112,
          gmtCreate: 1688551480000,
          gmtModified: 1688551482000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shopee_collection",
          serivcePointName: "shopee打款",
          normal: "no",
          normalLimit: null,
          normalLimitUnit: null,
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: null,
          vip1LimitUnit: null,
          vip2: "limitless",
          vip2Limit: null,
          vip2LimitUnit: null,
          vip3: "limitless",
          vip3Limit: null,
          vip3LimitUnit: null,
          vip4: "limitless",
          vip4Limit: null,
          vip4LimitUnit: null,
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: "包括shopee回款",
          serviceGroup: "数据统计",
          seq: "70",
          isOpened: "y",
        },
        "1688_product_monitor": {
          id: 135,
          gmtCreate: 1655799672000,
          gmtModified: 1655799675000,
          creator: "",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "1688_product_monitor",
          serivcePointName: "产品监控",
          normal: "limit",
          normalLimit: "10",
          normalLimitUnit: "条",
          vip0: "limit",
          vip0Limit: "100",
          vip0LimitUnit: "条",
          vip1: "limit",
          vip1Limit: "200",
          vip1LimitUnit: "条",
          vip2: "limit",
          vip2Limit: "500",
          vip2LimitUnit: "条",
          vip3: "limit",
          vip3Limit: "1000",
          vip3LimitUnit: "条",
          vip4: "limit",
          vip4Limit: "2000",
          vip4LimitUnit: "条",
          vip5: "limit",
          vip5Limit: "5000",
          vip5LimitUnit: "条",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "100",
          isOpened: "y",
        },
        generate_video: {
          id: 75,
          gmtCreate: 1655799672000,
          gmtModified: 1655799675000,
          creator: "",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "generate_video",
          serivcePointName: "图片生成视频",
          normal: "no",
          normalLimit: "",
          normalLimitUnit: "",
          vip0: "limit",
          vip0Limit: "25",
          vip0LimitUnit: "次/天",
          vip1: "limit",
          vip1Limit: "50",
          vip1LimitUnit: "次/天",
          vip2: "limit",
          vip2Limit: "80",
          vip2LimitUnit: "次/天",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "次/天",
          vip4: "limit",
          vip4Limit: "120",
          vip4LimitUnit: "次/天",
          vip5: "limit",
          vip5Limit: "300",
          vip5LimitUnit: "次/天",
          serviceNew: null,
          note: null,
          serviceGroup: "产品刊登",
          seq: "99",
          isOpened: "y",
        },
        shop_count_other_b2w: {
          id: 87,
          gmtCreate: 1668393211000,
          gmtModified: 1668393211000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_b2w",
          serivcePointName: "Americanas（B2W）",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
        logistics_tracking_sync: {
          id: 73,
          gmtCreate: 1643109197000,
          gmtModified: 1643109197000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "logistics_tracking_sync",
          serivcePointName: "物流追踪自动同步",
          normal: "no",
          normalLimit: "",
          normalLimitUnit: "",
          vip0: "limitless",
          vip0Limit: "",
          vip0LimitUnit: "",
          vip1: "limitless",
          vip1Limit: "",
          vip1LimitUnit: "",
          vip2: "limitless",
          vip2Limit: "",
          vip2LimitUnit: "",
          vip3: "limitless",
          vip3Limit: "",
          vip3LimitUnit: "",
          vip4: "limitless",
          vip4Limit: "",
          vip4LimitUnit: "",
          vip5: "limitless",
          vip5Limit: "",
          vip5LimitUnit: "",
          serviceNew: null,
          note: null,
          serviceGroup: "物流管理",
          seq: "30",
          isOpened: "y",
        },
        shop_count_other_meesho: {
          id: 59,
          gmtCreate: 1568099692000,
          gmtModified: 1568099692000,
          creator: "sys",
          modifier: "sys",
          isDeleted: "n",
          userId: null,
          startIndex: null,
          pageSize: null,
          orderBy: null,
          groupBy: null,
          servicePoint: "shop_count_other_meesho",
          serivcePointName: "meesho店铺数",
          normal: "limit",
          normalLimit: "2",
          normalLimitUnit: "个",
          vip0: "limit",
          vip0Limit: "10",
          vip0LimitUnit: "个",
          vip1: "limit",
          vip1Limit: "10",
          vip1LimitUnit: "个",
          vip2: "limit",
          vip2Limit: "40",
          vip2LimitUnit: "个",
          vip3: "limit",
          vip3Limit: "100",
          vip3LimitUnit: "个",
          vip4: "limit",
          vip4Limit: "215",
          vip4LimitUnit: "个",
          vip5: "limit",
          vip5Limit: "500",
          vip5LimitUnit: "个",
          serviceNew: null,
          note: null,
          serviceGroup: "通用服务",
          seq: "40",
          isOpened: "y",
        },
      };

      vm.list = groupList(dataMap, true);

      vm.edm = dataMap.edm_email_num;

      vm.vipList = resetFeeList(vm.vipList);

      angular.forEach(vm.vipList, function(item) {
        item.edmNum = vm.edm[item.businessType + "Limit"];
        item.edmNumUnit = vm.edm[item.businessType + "LimitUnit"];
      });

      var queryclass;

      vm.pay = function () {
        queryclass = document.querySelector('.isonline-class');
        if (queryclass) {
          window.location.assign('/erp/#/erp/personal/servicelimit');
          return;
        }
        vm.trueBox = true;
      };

      vm.payserviceextend = function () {
        queryclass = document.querySelector('.isonline-class');
        if (queryclass) {
          window.location.assign('/erp/#/erp/personal/serviceextend/2');
          return;
        }
        vm.trueBox = true;
      };

      vm.save = function () {
        window.location.assign('/login#/signin/erp/%23/erp/personal/servicelimit');
      };
      vm.cancel = function () {
        vm.trueBox = false;
      };

    },
  ])
  .filter("noteShopFilter", [
    "$sce",
    function($sce) {
      return function(v) {
        var arr1 = v.split(":");
        var arr = arr1[1].split(",");
        var str = '<div class="row" style="width: 85%;margin-left: 21px;background:#f9f9f9;border-radius: 5px;padding-top: 6px;padding-bottom: 6px;line-height: 1.8em;margin-top: 5px;">';
        str += '<div class="col-xs-12">' + arr1[0] + "：</div>";
        str += '<div class="col-xs-12">';
        str += arr.join('</div><div class="col-xs-12">');
        str += "</div>";
        str += "</div>";
        str = $sce.trustAsHtml(str);
        return str;
      };
    },
  ]);
